import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'

const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectRubro
 * @description Select para los rubros registrados en el sistema, relacionados a un area
 */
const SelectRubro = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione el Rubro", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        area_id
    } = props


    const [ rubros, setRubros ] = useState({
        data: [],
        page: 1,
        limit: 100,
        total: 0,
        search: null,
    })


    /**
     * @const getRubros
     * @description Obitiene las rubros
     */
    const getRubros = ({page, limit, search} = rubros) => {

        axios.get('/rubros', {
            params: {
                page,
                limit,
                search,
                area_id,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
        	console.log("data", data);
            setRubros(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener los rubros')
        })
    }

    //componentDidMount
    useEffect(() => {
        if(area_id)
            getRubros()
    }, [area_id])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            onSearch={(search)=> getRubros({search})}
            onSelect={(rubro)=> {
                onChange(rubro.value)
                onSelect(rubro.value)
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                rubros?.data?.map(({ _id, nombre }) => <Option value={_id} >
                    {nombre ?? ""}
                </Option>)
            }
        </Select>
    );
}



export default SelectRubro;